import './WebcamCard.scss';
import * as React from 'react';
import { SearchResultWebcam } from 'src/state/SearchResult';
import { getClasses } from 'src/utils/classFunctions';
import { classList } from 'src/utils/classList';
import { ResponsiveImage } from 'src/components/ResponsiveImage';

type Props = {
    readonly modificators?: ReadonlyArray<string>;
    readonly variant?: string;
    readonly searchItem: SearchResultWebcam;
};

export function WebcamCard(props: Props): JSX.Element {
    const { modificators = [], variant, searchItem } = props;

    return (
        <a href={searchItem.searchItem.url}
           target="_blank"
           className={classList(getClasses('lvo-webcam-card', modificators), variant)}>
            <div className="lvo-webcam-card__img-container lvo-webcam-card__img--center">
                <div className="lvo-webcam-card__img">
                    <ResponsiveImage src={searchItem.searchItem.image}/>
                </div>
            </div>
            <div className="lvo-webcam-card__caption-wrapper">
                <div className="lvo-webcam-card__caption">
                    <div className="lvo-webcam-card__container">
                        {searchItem.webcamLocation}
                        <strong className="lvo-webcam-card__title">
                            {searchItem.searchItem.title}
                        </strong>
                    </div>
                </div>
            </div>
        </a>
    );
}
